import { render, staticRenderFns } from "./lpn-details-comp.vue?vue&type=template&id=5fec5da6&"
import script from "./js/lpn-details-comp.js?vue&type=script&lang=js&"
export * from "./js/lpn-details-comp.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports